import React from 'react';
import ModalTypeEnum from 'Modals/ModalConstants';
import BaseModal from 'Modals/BaseModal';
import PropTypes from 'prop-types';
import { SelfServeBuilderSidePanelTypes } from 'SelfServeBuilderSidePanel/SelfServeBuilderSidePanelConstants';
import AddRecipientsModalBody from './AddRecipientsModalBody';

export default class AddRecipientsConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.sendToRecipient = this.sendToRecipient.bind(this);
    this.state = {
      showConfirmationModal: true,
    };
  }

  closeModal() {
    this.state = {
      showConfirmationModal: false,
    };
  }

  sendToRecipient() {
    this.props.send();
    this.props.closePanel(SelfServeBuilderSidePanelTypes.POST_BUILDER);
  }

  render() {
    return (
      <BaseModal
        modalType={ModalTypeEnum.SELF_SERVE_ADD_RECIPIENTS_CONFIRM}
        activeModal={this.props.activeModal}
        isOpen={this.props.isOpen}
        closeModal={this.props.close}
        includeHeaderCloseButton
        bodyContent={(
          <AddRecipientsModalBody
            onSend={this.sendToRecipient}
            onCancel={this.props.close}
          />
        )}
      />
    );
  }
}

AddRecipientsConfirmationModal.defaultProps = {
  activeModal: '',
};

AddRecipientsConfirmationModal.propTypes = {
  activeModal: PropTypes.oneOf([
    ModalTypeEnum.SELF_SERVE_ADD_RECIPIENTS_CONFIRM,
    ModalTypeEnum.SELF_SERVE_PUBLISH_TEMPLATE_CONFIRM,
    '',
  ]),
  close: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  send: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/AddRecipientsConfirmationModal/index.jsx